import { isEmpty } from 'lodash';

const cvss2 = 'cvss2';
const cvss3 = 'cvss3';
const cvss4 = 'cvss4';

const cvss2Label = 'CVSS v2.0';
const cvss3Label = 'CVSS v3.1';
const cvss4Label = 'CVSS v4.0';

export const CVSS_PATTERNS = {
  [cvss2]: /^AV:[NAL]\/AC:[LH]\/Au:[NSM]\/C:[CNP]\/I:[CNP]\/A:[CNP]$/,
  [cvss3]: /^CVSS:3\.1\/AV:(N|A|L|P)\/AC:(L|H)\/PR:(N|L|H)\/UI:(N|R)\/S:(U|C)\/C:(N|L|H)\/I:(N|L|H)\/A:(N|L|H)$/,
  [cvss4]: /^CVSS:4\.0\/AV:(N|A|L|P)\/AC:(L|H)\/AT:(N|P)\/PR:(N|L|H)\/UI:(N|A|R|P)\/VC:(N|L|H)\/VI:(N|L|H)\/VA:(N|L|H)\/SC:(N|L|H)\/SI:(N|L|H)\/SA:(N|L|H)(\/E:(X|U|P|A))?(\/CR:(L|M|H))?(\/IR:(L|M|H))?(\/AR:(L|M|H))?(\/MAV:(N|A|L|P))?(\/MAC:(L|H))?(\/MAT:(N|P))?(\/MPR:(N|L|H))?(\/MUI:(N|P|A))?(\/MVC:(N|L|H))?(\/MVI:(N|L|H))?(\/MVA:(N|L|H))?(\/MSC:(N|L|H))?(\/MSI:(N|L|H|S))?(\/MSI:(N|L|H|S))?(\/MSA:(N|L|H|S))?(\/S:[A-Z])?(\/AU:[A-Z])?(\/R:[A-Z])?(\/V:[A-Z])?(\/RE:[A-Z])?(\/U:[A-Za-z]+)?$/
};

export const CVSS_TYPES = {
  [cvss2Label]: cvss2,
  [cvss3Label]: cvss3,
  [cvss4Label]: cvss4
};

export const CVSS_TYPES_LABELS = {
  [cvss2]: cvss2Label,
  [cvss3]: cvss3Label,
  [cvss4]: cvss4Label
};

export const DEFAULT_CVSS_TYPE = cvss3;

export const hasCVSSValue = (value) => value !== null && typeof value !== 'undefined' && String(value).trim() !== '';

export const isCVSSScore = (value) => {
  if (!hasCVSSValue(value)) return false;
  const stringValue = String(value).trim();
  if (!/^\d+(\.\d+)?$/.test(stringValue)) return false;

  const parsedValue = Number(stringValue);
  return parsedValue >= 0 && parsedValue <= 10;
};

export const parseCVSSEntry = (value, type) => {
  const trimmedValue = String(hasCVSSValue(value) ? value : '').trim();

  if (isCVSSScore(trimmedValue)) {
    return {
      base_score: Number(trimmedValue),
      vector_string: ''
    };
  }

  if (CVSS_PATTERNS[type]?.test(trimmedValue)) {
    return {
      vector_string: trimmedValue
    };
  }

  return null;
};

export const getCVSSType = (vulnTemplate) => {
  const keys = Object.keys(vulnTemplate) || [];
  const types = Object.values(CVSS_TYPES) || [];

  return types.find(type => keys.includes(type) && (!isEmpty(vulnTemplate[type]?.vector_string) || hasCVSSValue(vulnTemplate[type]?.base_score)));
};

export const validEntry = (vector, type) => {
  return !!parseCVSSEntry(vector, type);
};

export const isWrong = (vector, type) => {
  return hasCVSSValue(vector) && !validEntry(vector, type);
};
